import React, { useEffect, useState } from "react";
import { useAuth } from "../../context/AuthContext";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import { getConsentText, acceptConsent } from "../../services/Consent";
import CardHeader from "../../components/common/CardHeader";
import LoadingSpinner from "../../components/common/LoadingSpinner";


import logger from "../../utils/logger";
const AddConsent = () => {
  const { accessToken } = useAuth();
  const { userId } = useAuth();
  let navigate = useNavigate();
  let { consentType } = useParams();
  let consentTypes = ["Zgoda informacyjna", "Zgoda informacyjna"];
  const [consentText, setConsentText] = useState("");

  const handleAccept = async (e) => {
    e.preventDefault();
    const result = await acceptConsent(consentType, userId, accessToken);
    if (result) {
      navigate("/user/profile", { replace: true });
    }
  };

  const handleCancel = async (e) => {
    e.preventDefault();
    navigate("/user/profile", { replace: true });
  };

  useEffect(() => {
    const fetchData = async () => {
      const cText = await getConsentText(consentType, accessToken);
      setConsentText(cText);
    };

    fetchData();
  }, [userId, accessToken]);

  logger.log("Akceptacja zgody: " + consentType);

  return (
    <div className="d-flex flex-fill flex-column">
      <CardHeader text={"Akceptacja zgody"} onlyText="true" />
      <div className="card container-fluid shadow mx-4 px-4 py-3 w55">
        <h4>{consentTypes[consentType - 1]}</h4>
        {consentText === "" && <LoadingSpinner />}
        {consentText !== "" && (
          <div>
            <div className="mb-2">{consentText}</div>
            <div className="flex-column">
              <form onSubmit={handleAccept}>
                <div className="d-flex flex-row flex-wrap">
                  <button
                    className="btn btn-outline-primary rounded-2 me-auto w7 h2"
                    onClick={handleCancel}
                  >
                    Anuluj
                  </button>
                  <button
                    type="submit"
                    className="btn btn-primary rounded-2 ms-auto w7 h2"
                  >
                    Zaakceptuj
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default AddConsent;


